module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 8-79bbd352dc007c6b65f4c7d8013589ba.jpg";